var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1588_15491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.975 13.4062H35.875V9.28125C35.875 8.71406 35.4137 8.25 34.85 8.25H32.8C32.2362 8.25 31.775 8.71406 31.775 9.28125V13.4062H27.675C27.1112 13.4062 26.65 13.8703 26.65 14.4375V16.5C26.65 17.0672 27.1112 17.5312 27.675 17.5312H31.775V21.6562C31.775 22.2234 32.2362 22.6875 32.8 22.6875H34.85C35.4137 22.6875 35.875 22.2234 35.875 21.6562V17.5312H39.975C40.5387 17.5312 41 17.0672 41 16.5V14.4375C41 13.8703 40.5387 13.4062 39.975 13.4062ZM14.35 16.5C18.8792 16.5 22.55 12.8068 22.55 8.25C22.55 3.69316 18.8792 0 14.35 0C9.82078 0 6.15 3.69316 6.15 8.25C6.15 12.8068 9.82078 16.5 14.35 16.5ZM20.09 18.5625H19.0202C17.598 19.2199 16.0156 19.5938 14.35 19.5938C12.6844 19.5938 11.1084 19.2199 9.67984 18.5625H8.61C3.85656 18.5625 0 22.4426 0 27.225V29.9062C0 31.6143 1.37734 33 3.075 33H25.625C27.3227 33 28.7 31.6143 28.7 29.9062V27.225C28.7 22.4426 24.8434 18.5625 20.09 18.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_15491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/userPlus.05e574b5d967a8d7db0263a224af1357.svg";
export { ForwardRef as ReactComponent };